import ResetPassword from "components/Login/ResetPassword";
import React from "react";

const ResetPasswordPage: React.FC = () => {
  return (
    <>
      <ResetPassword />
    </>
  );
};

export default ResetPasswordPage;
